<y42-context-menu-color-button
  [color]="textColor || defaultTextColor"
  [faIcon]="['fas', 'font']"
  [addBackground]="true"
  tooltip="Color"
  (colorChanged)="textColorChanged.emit($event)"
></y42-context-menu-color-button>
